import Keycloak from 'keycloak-js';
import { useDispatch } from 'react-redux';
import { refreshToken } from '../store/authSlice';
import store from '../../../store/store';

class KeycloakSingleton {

    constructor() {
        if (!KeycloakSingleton.instance) {
            this._keycloak = null;
            this._isInitialized = false;
            KeycloakSingleton.instance = this;
            this._refreshInterval = null;
        }
        return KeycloakSingleton.instance;
    }

    /**
     * Initialize the Keycloak instance with dynamic settings.
     * @param {Object} settings - Keycloak configuration (url, realm, clientId).
     * @returns {Promise<boolean>} - Whether the user is authenticated.
     */
    async init(settings) {
        if (!this._keycloak && !this._isInitialized) {
            this._keycloak = new Keycloak(settings);
            try {
                // Check if this is a callback URL
                const isCallback = window.location.search.includes('state=') ||
                    window.location.hash.includes('state=');

                const authenticated = await this._keycloak.init({
                    onLoad: isCallback ? 'check-sso' : 'login-required',
                    checkLoginIframe: false,
                    enableLogging: true // Enable for debugging
                });


                this._isInitialized = true;


                if (authenticated) {
                    this.setupTokenRefresh();

                    if (isCallback) {
                        window.history.replaceState({}, document.title, window.location.pathname);
                    }
                }

                return authenticated;
            } catch (error) {
                console.error('Keycloak initialization failed:', error);
                throw error;
            }
        }
        return this.isAuthenticated();
    }


    resetInstance() {
        this._keycloak = null;
        this._isInitialized = false;
    }

    /**
     * Check if the Keycloak instance is initialized.
     * @returns {boolean}
     */
    getIsInitialized() {
        return this._isInitialized;
    }

    /**
     * Get the Keycloak instance.
     * @returns {Keycloak|null}
     */
    getInstance() {
        return this._keycloak;
    }

    /**
     * Check if the user is authenticated.
     * @returns {boolean}
     */
    isAuthenticated() {
        return !!this._keycloak?.token;
    }
    setupTokenRefresh() {
        console.log("[Keycloak] Surveillance du token activée");

        this._refreshInterval = setInterval(async () => {
            if (this._keycloak && this._keycloak.tokenParsed) {
                try {
                    const refreshed = await this._keycloak.updateToken(1200);
                    if (refreshed) {
                        console.log('[Keycloak] Token rafraîchi avec succès !');
                        store.dispatch(refreshToken(this._keycloak.token));
                    } else {
                        console.log('[Keycloak] Pas encore besoin de rafraîchir.');
                    }
                } catch (error) {
                    console.error('[Keycloak] Session expirée ou erreur réseau', error);
                    this._keycloak.logout();
                }
            }
        }, 600000);
    }

}

// Export a single instance of the KeycloakWrapper
const keycloakWrapper = new KeycloakSingleton();
export default keycloakWrapper;